"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePersistedStateObject = void 0;
var react_1 = require("react");
var utils_1 = require("../utils");
function usePersistedStateObject(key, subKey, initialState) {
    var getLocalStorageValue = function (key) {
        var result = undefined;
        var localStorageValue = localStorage.getItem(key);
        if (!!localStorageValue) {
            try {
                result = JSON.parse(localStorageValue);
            }
            catch (_a) {
                result = localStorageValue;
            }
        }
        return result;
    };
    var readSubKey = function (key, subKey) {
        var stored = getLocalStorageValue(key);
        return (0, utils_1.isObject)(stored)
            ? stored[subKey]
            : undefined;
    };
    var _a = (0, react_1.useState)(function () {
        var result = getLocalStorageValue(key);
        return (0, utils_1.isObject)(result)
            ? !!subKey
                ? result[subKey]
                : initialState
            : result || initialState;
    }), state = _a[0], setState = _a[1];
    // The initialiser above runs once, and the caller may not know who the user
    // is yet: the channel context mounts while Keycloak is still initialising,
    // so subKey arrives a render late and there was no bucket to read from.
    // Read the stored value once the key it is filed under finally appears.
    var _b = (0, react_1.useState)(subKey || undefined), hydratedFor = _b[0], setHydratedFor = _b[1];
    (0, react_1.useEffect)(function () {
        if (!subKey || hydratedFor === subKey)
            return;
        var stored = readSubKey(key, subKey);
        setHydratedFor(subKey);
        if (stored !== undefined && stored !== null) {
            setState(stored);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [key, subKey, hydratedFor]);
    (0, react_1.useEffect)(function () {
        var _a, _b;
        // Never write an empty state over a stored one. State is null both before
        // the user has chosen and before the hydration above has run, and writing
        // that back erased the very choice we were about to read.
        if (state === undefined || state === null || !subKey)
            return;
        var localStorageValue = getLocalStorageValue(key);
        if (localStorageValue === undefined)
            localStorageValue = (_a = {}, _a[subKey] = state, _a);
        else if ((0, utils_1.isObject)(localStorageValue))
            localStorageValue[subKey] = state;
        else
            localStorageValue = (_b = {}, _b[subKey] = state, _b);
        localStorage.setItem(key, JSON.stringify(localStorageValue));
    }, [key, subKey, state]);
    return [state, setState];
}
exports.usePersistedStateObject = usePersistedStateObject;
